import { useFormContext, useWatch } from 'react-hook-form';
import FormCheckbox from 'components/common/forms/FormCheckbox';
import FormRadioBtn from 'components/common/forms/FormRadioBtn';
import FormTextarea from 'components/common/forms/FormTextarea';
import QuarantCheckbox from './QuarantCheckbox';
import styles from 'styles/pages/chart/DentalHistoryChart.module.scss';
import {
  DentalHistoryChartFields,
  Symptom,
  SymptomLabel,
} from 'constants/chart/dentalHistoryChart';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import useModal from 'hooks/useModal';

const textareaStyle = {
  border: `1px solid ${STYLES_VARIABLES.GRAY_03}`,
  width: 'calc(100% - 140px)',
  height: '80px',
  padding: '12px 16px',
};

const fullTextareaStyle = {
  border: `1px solid ${STYLES_VARIABLES.GRAY_03}`,
  width: '100%',
  height: '80px',
  padding: '12px 16px',
};

type TProps = {
  isRegister: boolean;
};

const SymptomTable = ({ isRegister }: TProps) => {
  const { openModal } = useModal();

  const { setValue, control } = useFormContext();

  const symptom1Watch = useWatch({
    name: DentalHistoryChartFields.Symptom1,
    control,
  });
  const symptom1DetailWatch = useWatch({
    name: [
      DentalHistoryChartFields.Symptom1Check,
      DentalHistoryChartFields.Symptom1Text,
    ],
    control,
  });

  const symptom2Watch = useWatch({
    name: DentalHistoryChartFields.Symptom2,
    control,
  });
  const symptom2DetailWatch = useWatch({
    name: DentalHistoryChartFields.Symptom2Text,
    control,
  });

  const symptom3Watch = useWatch({
    name: DentalHistoryChartFields.Symptom3,
    control,
  });
  const symptom3DetailWatch = useWatch({
    name: [
      DentalHistoryChartFields.Symptom3Check,
      DentalHistoryChartFields.Symptom3Text,
    ],
    control,
  });

  const symptom4Watch = useWatch({
    name: DentalHistoryChartFields.Symptom4,
    control,
  });
  const symptom4DetailWatch = useWatch({
    name: [
      DentalHistoryChartFields.Symptom4Check,
      DentalHistoryChartFields.Symptom4Text,
    ],
    control,
  });

  const symptom5Watch = useWatch({
    name: DentalHistoryChartFields.Symptom5,
    control,
  });
  const symptom5DetailWatch = useWatch({
    name: [
      DentalHistoryChartFields.Symptom5Check,
      DentalHistoryChartFields.Symptom5Text,
    ],
    control,
  });

  const symptom6Watch = useWatch({
    name: DentalHistoryChartFields.Symptom6,
    control,
  });
  const symptom6DetailWatch = useWatch({
    name: DentalHistoryChartFields.Symptom6Text,
    control,
  });

  const symptom7Watch = useWatch({
    name: DentalHistoryChartFields.Symptom7,
    control,
  });
  const symptom7DetailWatch = useWatch({
    name: DentalHistoryChartFields.Symptom7Text,
    control,
  });

  const symptom8Watch = useWatch({
    name: DentalHistoryChartFields.Symptom8,
    control,
  });
  const symptom8DetailWatch = useWatch({
    name: [
      DentalHistoryChartFields.Symptom8Check,
      DentalHistoryChartFields.Symptom8Text,
    ],
    control,
  });

  const symptom9Watch = useWatch({
    name: DentalHistoryChartFields.Symptom9,
    control,
  });
  const symptom9DetailWatch = useWatch({
    name: DentalHistoryChartFields.Symptom9Text,
    control,
  });

  const symptom10Watch = useWatch({
    name: DentalHistoryChartFields.Symptom10,
    control,
  });
  const symptom10DetailWatch = useWatch({
    name: [
      DentalHistoryChartFields.Symptom10Check,
      DentalHistoryChartFields.Symptom10Text,
    ],
    control,
  });

  const symptom11Watch = useWatch({
    name: DentalHistoryChartFields.Symptom11,
    control,
  });

  const symptom12Watch = useWatch({
    name: DentalHistoryChartFields.Symptom12,
    control,
  });
  const symptom12DetailWatch = useWatch({
    name: [
      DentalHistoryChartFields.Symptom12Check,
      DentalHistoryChartFields.Symptom12Text,
    ],
    control,
  });

  const symptom13Watch = useWatch({
    name: DentalHistoryChartFields.Symptom13,
    control,
  });
  const symptom13DetailWatch = useWatch({
    name: DentalHistoryChartFields.Symptom13Text,
    control,
  });

  const symptom14Watch = useWatch({
    name: DentalHistoryChartFields.Symptom14,
    control,
  });
  const symptom14DetailWatch = useWatch({
    name: [
      DentalHistoryChartFields.Symptom14Check,
      DentalHistoryChartFields.Symptom14Text,
    ],
    control,
  });

  const symptom15Watch = useWatch({
    name: DentalHistoryChartFields.Symptom15,
    control,
  });
  const symptom15DetailWatch = useWatch({
    name: [
      DentalHistoryChartFields.Symptom15Check,
      DentalHistoryChartFields.Symptom15Text,
    ],
    control,
  });

  const symptom16Watch = useWatch({
    name: DentalHistoryChartFields.Symptom16,
    control,
  });
  const symptom16DetailWatch = useWatch({
    name: [
      DentalHistoryChartFields.Symptom16Check,
      DentalHistoryChartFields.Symptom16Text,
    ],
    control,
  });

  const symptom17Watch = useWatch({
    name: DentalHistoryChartFields.Symptom17,
    control,
  });
  const symptom17DetailWatch = useWatch({
    name: DentalHistoryChartFields.Symptom17Text,
    control,
  });

  return (
    <table className="w100">
      <thead>
        <tr className={styles.thead_tr}>
          <th className={styles.th_border_right}>증상</th>
          <th className={styles.th}>세부사항</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className={styles.td}>
            <FormCheckbox
              id={SymptomLabel[Symptom.Symptom1]}
              name={DentalHistoryChartFields.Symptom1}
              text={SymptomLabel[Symptom.Symptom1]}
              value={Symptom.Symptom1}
              readOnly={!isRegister}
              afterChange={() => {
                if (
                  symptom1Watch &&
                  (symptom1DetailWatch[0].length > 0 || symptom1DetailWatch[1])
                ) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom1,
                        Symptom.Symptom1
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom1Check, []);
                      setValue(DentalHistoryChartFields.Symptom1Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.touch_wrapper}>
            <QuarantCheckbox
              name={DentalHistoryChartFields.Symptom1Check}
              readOnly={!isRegister || !symptom1Watch}
            />
            <FormTextarea
              name={DentalHistoryChartFields.Symptom1Text}
              textareaStyle={textareaStyle}
              maxLength={30}
              placeholder="최대 30자까지 입력 가능합니다."
              readOnly={!isRegister || !symptom1Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom2}
              text={SymptomLabel[Symptom.Symptom2]}
              value={Symptom.Symptom2}
              readOnly={!isRegister}
              afterChange={() => {
                if (symptom2Watch && symptom2DetailWatch) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom2,
                        Symptom.Symptom2
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom2Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.td_text_wrapper}>
            <FormTextarea
              name={DentalHistoryChartFields.Symptom2Text}
              textareaStyle={fullTextareaStyle}
              maxLength={30}
              placeholder="최대 30자까지 입력 가능합니다."
              readOnly={!isRegister || !symptom2Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom3}
              text={SymptomLabel[Symptom.Symptom3]}
              value={Symptom.Symptom3}
              readOnly={!isRegister}
              afterChange={() => {
                if (
                  symptom3Watch &&
                  (symptom3DetailWatch[0].length > 0 || symptom3DetailWatch[1])
                ) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom3,
                        Symptom.Symptom3
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom3Check, []);
                      setValue(DentalHistoryChartFields.Symptom3Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.touch_wrapper}>
            <QuarantCheckbox
              name={DentalHistoryChartFields.Symptom3Check}
              readOnly={!isRegister || !symptom3Watch}
            />
            <FormTextarea
              name={DentalHistoryChartFields.Symptom3Text}
              textareaStyle={textareaStyle}
              maxLength={30}
              placeholder="최대 30자까지 입력 가능합니다."
              readOnly={!isRegister || !symptom3Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom4}
              text={SymptomLabel[Symptom.Symptom4]}
              value={Symptom.Symptom4}
              readOnly={!isRegister}
              afterChange={() => {
                if (
                  symptom4Watch &&
                  (symptom4DetailWatch[0].length > 0 || symptom4DetailWatch[1])
                ) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom4,
                        Symptom.Symptom4
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom4Check, []);
                      setValue(DentalHistoryChartFields.Symptom4Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.touch_wrapper}>
            <QuarantCheckbox
              name={DentalHistoryChartFields.Symptom4Check}
              readOnly={!isRegister || !symptom4Watch}
            />
            <FormTextarea
              name={DentalHistoryChartFields.Symptom4Text}
              textareaStyle={textareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom4Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom5}
              text={SymptomLabel[Symptom.Symptom5]}
              value={Symptom.Symptom5}
              readOnly={!isRegister}
              afterChange={() => {
                if (
                  symptom5Watch &&
                  (symptom5DetailWatch[0].length > 0 || symptom5DetailWatch[1])
                ) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom5,
                        Symptom.Symptom5
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom5Check, []);
                      setValue(DentalHistoryChartFields.Symptom5Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.touch_wrapper}>
            <QuarantCheckbox
              name={DentalHistoryChartFields.Symptom5Check}
              readOnly={!isRegister || !symptom5Watch}
            />
            <FormTextarea
              name={DentalHistoryChartFields.Symptom5Text}
              textareaStyle={textareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom5Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom6}
              text={SymptomLabel[Symptom.Symptom6]}
              value={Symptom.Symptom6}
              readOnly={!isRegister}
              afterChange={() => {
                if (symptom6Watch && symptom6DetailWatch) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom6,
                        Symptom.Symptom6
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom6Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.td_text_wrapper}>
            <FormTextarea
              name={DentalHistoryChartFields.Symptom6Text}
              textareaStyle={fullTextareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom6Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom7}
              text={SymptomLabel[Symptom.Symptom7]}
              value={Symptom.Symptom7}
              readOnly={!isRegister}
              afterChange={() => {
                if (symptom7Watch && symptom7DetailWatch) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom7,
                        Symptom.Symptom7
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom7Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.td_text_wrapper}>
            <FormTextarea
              name={DentalHistoryChartFields.Symptom7Text}
              textareaStyle={fullTextareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom7Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom8}
              text={SymptomLabel[Symptom.Symptom8]}
              value={Symptom.Symptom8}
              readOnly={!isRegister}
              afterChange={() => {
                if (
                  symptom8Watch &&
                  (symptom8DetailWatch[0].length > 0 || symptom8DetailWatch[1])
                ) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom8,
                        Symptom.Symptom8
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom8Check, []);
                      setValue(DentalHistoryChartFields.Symptom8Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.touch_wrapper}>
            <QuarantCheckbox
              name={DentalHistoryChartFields.Symptom8Check}
              readOnly={!isRegister || !symptom8Watch}
            />
            <FormTextarea
              name={DentalHistoryChartFields.Symptom8Text}
              textareaStyle={textareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom8Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom9}
              text={SymptomLabel[Symptom.Symptom9]}
              value={Symptom.Symptom9}
              readOnly={!isRegister}
              afterChange={() => {
                if (symptom9Watch && symptom9DetailWatch) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom9,
                        Symptom.Symptom9
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom9Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.td_text_wrapper}>
            <FormTextarea
              name={DentalHistoryChartFields.Symptom9Text}
              textareaStyle={fullTextareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom9Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom10}
              text={SymptomLabel[Symptom.Symptom10]}
              value={Symptom.Symptom10}
              readOnly={!isRegister}
              afterChange={() => {
                if (
                  symptom10Watch &&
                  (symptom10DetailWatch[0].length > 0 ||
                    symptom10DetailWatch[1])
                ) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom10,
                        Symptom.Symptom10
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom10Check, []);
                      setValue(DentalHistoryChartFields.Symptom10Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.touch_wrapper}>
            <QuarantCheckbox
              name={DentalHistoryChartFields.Symptom10Check}
              readOnly={!isRegister || !symptom10Watch}
            />
            <FormTextarea
              name={DentalHistoryChartFields.Symptom10Text}
              textareaStyle={textareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom10Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom11}
              text={SymptomLabel[Symptom.Symptom11]}
              value={Symptom.Symptom11}
              readOnly={!isRegister}
              afterChange={(value) => {
                const valueAsArray = value as string[];
                if (!valueAsArray.includes(SymptomLabel[Symptom.Symptom11])) {
                  setValue(DentalHistoryChartFields.Symptom11Text, null);
                }
              }}
            />
          </td>
          <td className={styles.td_radio_wrapper}>
            {/* 라디오 버튼 */}
            <FormRadioBtn
              name={DentalHistoryChartFields.Symptom11Text}
              value="아침에만"
              labelText="아침에만"
              labelStyle={{ marginRight: '80px' }}
              readOnly={!isRegister}
              disabled={
                !symptom11Watch?.includes(SymptomLabel[Symptom.Symptom11])
              }
            />
            <FormRadioBtn
              name={DentalHistoryChartFields.Symptom11Text}
              value="항상"
              labelText="항상"
              readOnly={!isRegister}
              disabled={
                !symptom11Watch?.includes(SymptomLabel[Symptom.Symptom11])
              }
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom12}
              text={SymptomLabel[Symptom.Symptom12]}
              value={Symptom.Symptom12}
              readOnly={!isRegister}
              afterChange={() => {
                if (
                  symptom12Watch &&
                  (symptom12DetailWatch[0].length > 0 ||
                    symptom12DetailWatch[1])
                ) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom12,
                        Symptom.Symptom12
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom12Check, []);
                      setValue(DentalHistoryChartFields.Symptom12Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.touch_wrapper}>
            <QuarantCheckbox
              name={DentalHistoryChartFields.Symptom12Check}
              readOnly={!isRegister || !symptom12Watch}
            />
            <FormTextarea
              name={DentalHistoryChartFields.Symptom12Text}
              textareaStyle={textareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom12Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom13}
              text={SymptomLabel[Symptom.Symptom13]}
              value={Symptom.Symptom13}
              readOnly={!isRegister}
              afterChange={() => {
                if (symptom13Watch && symptom13DetailWatch) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom13,
                        Symptom.Symptom13
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom13Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.td_text_wrapper}>
            <FormTextarea
              name={DentalHistoryChartFields.Symptom13Text}
              textareaStyle={fullTextareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom13Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom14}
              text={SymptomLabel[Symptom.Symptom14]}
              value={Symptom.Symptom14}
              readOnly={!isRegister}
              afterChange={() => {
                if (
                  symptom14Watch &&
                  (symptom14DetailWatch[0].length > 0 ||
                    symptom14DetailWatch[1])
                ) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom14,
                        Symptom.Symptom14
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom14Check, []);
                      setValue(DentalHistoryChartFields.Symptom14Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.touch_wrapper}>
            <QuarantCheckbox
              name={DentalHistoryChartFields.Symptom14Check}
              readOnly={!isRegister || !symptom14Watch}
            />
            <FormTextarea
              name={DentalHistoryChartFields.Symptom14Text}
              textareaStyle={textareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom14Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom15}
              text={SymptomLabel[Symptom.Symptom15]}
              value={Symptom.Symptom15}
              readOnly={!isRegister}
              afterChange={() => {
                if (
                  symptom15Watch &&
                  (symptom15DetailWatch[0].length > 0 ||
                    symptom15DetailWatch[1])
                ) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom15,
                        Symptom.Symptom15
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom15Check, []);
                      setValue(DentalHistoryChartFields.Symptom15Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.touch_wrapper}>
            <QuarantCheckbox
              name={DentalHistoryChartFields.Symptom15Check}
              readOnly={!isRegister || !symptom15Watch}
            />
            <FormTextarea
              name={DentalHistoryChartFields.Symptom15Text}
              textareaStyle={textareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom15Watch}
            />
          </td>
        </tr>

        <tr>
          <td className={styles.td}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom16}
              text={SymptomLabel[Symptom.Symptom16]}
              value={Symptom.Symptom16}
              readOnly={!isRegister}
              afterChange={() => {
                if (
                  symptom16Watch &&
                  (symptom16DetailWatch[0].length > 0 ||
                    symptom16DetailWatch[1])
                ) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom16,
                        Symptom.Symptom16
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom16Check, []);
                      setValue(DentalHistoryChartFields.Symptom16Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.touch_wrapper}>
            <QuarantCheckbox
              name={DentalHistoryChartFields.Symptom16Check}
              readOnly={!isRegister || !symptom16Watch}
            />
            <FormTextarea
              name={DentalHistoryChartFields.Symptom16Text}
              textareaStyle={textareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom16Watch}
            />
          </td>
        </tr>
        <tr>
          <td className={styles.td} style={{ borderBottom: '0' }}>
            <FormCheckbox
              name={DentalHistoryChartFields.Symptom17}
              text={SymptomLabel[Symptom.Symptom17]}
              value={Symptom.Symptom17}
              readOnly={!isRegister}
              afterChange={() => {
                if (symptom17Watch && symptom17DetailWatch) {
                  openModal({
                    isConfirm: true,
                    title: '작성 중인 내용을 삭제하시겠습니까?',
                    text: '작성 중인 내용이 삭제됩니다.',
                    onCancel: () => {
                      setValue(
                        DentalHistoryChartFields.Symptom17,
                        Symptom.Symptom17
                      );
                    },
                    onSubmit: () => {
                      setValue(DentalHistoryChartFields.Symptom17Text, '');
                    },
                  });
                }
              }}
            />
          </td>
          <td className={styles.td_text_wrapper} style={{ borderBottom: '0' }}>
            <FormTextarea
              name={DentalHistoryChartFields.Symptom17Text}
              textareaStyle={fullTextareaStyle}
              placeholder="최대 30자까지 입력 가능합니다."
              maxLength={30}
              readOnly={!isRegister || !symptom17Watch}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default SymptomTable;
